// @ts-nocheck
/**
 * Single entry point per row — opens the User Console drawer where every
 * per-user action lives, organized into tabs. Matches obd3-gui v1's
 * UserRowActions → UserConsole pattern (see UserConsole.tsx).
 *
 * Parent (UserListPage) owns all the API-calling handlers + existing
 * Bootstrap modals; this component just orchestrates the drawer's
 * open state.
 */
import { useState } from 'react';
import { Settings2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { UserConsole } from './UserConsole';

interface Props {
  user: any;
  canRead: boolean;
  canEdit: boolean;
  canDelete: boolean;
  isSwitchingAccount: boolean;
  canSwitchAccount?: boolean;
  onEdit: () => void;
  onSwitchAccount: () => void;
  onShowPassword: () => void;
  onResetPassword: () => void;
  onBlockToggle: () => void;
  onDelete: () => void;
  onViewHierarchy: () => void;
}

export function UserRowActions(props: Props) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        variant="ghost"
        size="icon"
        className="h-8 w-8"
        aria-label={`Open settings for ${props.user.username}`}
        title="Settings"
        onClick={() => setOpen(true)}
      >
        <Settings2 className="h-4 w-4" />
      </Button>

      <UserConsole open={open} onOpenChange={setOpen} {...props} />
    </>
  );
}
